import type { ReactNode, ReactElement } from 'react';
import { Component } from 'react';

import type { Nullable } from '@web-platform/global-components-types/utils';

type Props = {
  children: ReactElement;
  componentName: string;
  fallback: Nullable<ReactElement>;
  onError: (arg0: { component: string; error: Error }) => void;
};
type State = {
  hasError: boolean;
};

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    const { componentName = 'UnknownComponent', onError } = this.props;

    onError({
      component: componentName,
      error,
    });
  }

  render(): ReactNode {
    const { hasError } = this.state;
    const { children, fallback = null } = this.props;

    return hasError ? fallback : children;
  }
}

export default ErrorBoundary;
